import React from "react";
import Slider from "react-slick";
import styled from "styled-components";

const settings = {
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const data = [
  {
    title: "Provide healthy food and drinks at work functions",
    body: (
      <p>
        Offer healthy foods and drinks at meetings, conferences, lunches and
        celebrations. Healthy food can improve alertness and concentration,
        whilst helping the health of employees.
        <br />
        Switch the packet of biscuits and tray of sausage rolls for a fruit
        platter, sushi,{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-reset text-underline"
          href="/recipe/250/prawn---avocado-rice-paper-rolls"
        >
          rice paper rolls
        </a>
        ,{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-reset text-underline"
          href="/recipe/371/pumpkin---feta-mini-frittatas"
        >
          mini quiches
        </a>
        ,{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-reset text-underline"
          href="/recipe/tag/muffins"
        >
          low-sugar muffins
        </a>
        , or grainy{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-reset text-underline"
          href="/recipe/tag/wrap"
        >
          wraps
        </a>{" "}
        and{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-reset text-underline"
          href="/recipe/tag/sandwich"
        >
          sandwiches
        </a>{" "}
        packed with salad. Any unhealthy foods provided should be in small
        portion sizes and make up only a small proportion of the total offering.
        <br />
        For more ideas, see our blog on{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-reset text-underline"
          href="/news/How-to-host-a-healthy-morning-tea"
        >
          hosting a healthy morning tea
        </a>
        .
      </p>
    ),
  },
  {
    title: "Start a lunchtime walking group",
    body: (
      <p>
        Encourage employees to take a break from sitting and get some fresh air
        in their lungs by organising a regular lunchtime walking group. Promote
        the use of{" "}
        <a
          className="text-reset text-underline"
          href="https://www.sunsmart.com.au/protect-your-skin"
          target="_blank"
          rel="noopener noreferrer"
        >
          sun protection measures
        </a>{" "}
        including wearing a broad-brimmed hat, sunscreen and sunglasses when
        getting active.
      </p>
    ),
  },
  {
    title: "Promote quitting resources",
    body: (
      <p>
        The{" "}
        <a
          className="text-reset text-underline"
          href="https://www.makesmokinghistory.org.au/quit-toolkit/quit-toolkit-overview"
          target="_blank"
          rel="noopener noreferrer"
        >
          Make Smoking History website
        </a>{" "}
        provides information and resources for employees who want to quit
        smoking. It also includes information on quitting and has links to
        resources such as Quitline, which is a confidential telephone advice and
        information service.
      </p>
    ),
  },
  {
    title: "Register workplace teams to participate in physical events",
    body: (
      <p>
        Improve health while building a stronger workplace culture! Encourage
        employees to sign up for local physical activity events,{" "}
        <a
          className="text-reset text-underline"
          href="http://www.diabeteswa.com.au/prevention/healthy-lifestyle-programs/get-on-track-challenge"
          target="_blank"
          rel="noopener noreferrer"
        >
          challenges
        </a>{" "}
        or start your own in-house sporting competition.
      </p>
    ),
  },
  {
    title: "Make your lunchroom inviting",
    body: (
      <p>
        Provide space for employees to store and prepare food. This will make it
        easier for them to bring a healthy lunch from home. Items such as sharp
        knives, peelers and cutting boards can really make a difference.
      </p>
    ),
  },
  {
    title: "Encourage active travel",
    body: (
      <p>
        When people exercise before and during work, they are usually more
        productive throughout their day. Provide employees with{" "}
        <a
          className="text-reset text-underline"
          href="https://www.yourmove.org.au/resources/map-your-move-in-your-local-government-area"
          target="_blank"
          rel="noopener noreferrer"
        >
          active travel maps
        </a>{" "}
        which include information about local walking pathways, cycling routes,
        public transport timetables and promote your workplace&rsquo;s
        end-of-trip facilities.
      </p>
    ),
  },
  {
    title: "Remove rubbish and recycling bins from individual desks",
    body: (
      <p>
        Sitting at your desk all day is bad for your health. Promote{" "}
        <a
          className="text-reset text-underline"
          href="/be-active/move-more"
          target="_blank"
          rel="noopener noreferrer"
        >
          moving more
        </a>{" "}
        by relocating bins and printers to a central location to encourage
        employees to take a break from long periods of sitting.
      </p>
    ),
  },
  {
    title: "Hold standing or walking meetings",
    body: (
      <p>
        Experiencing meeting fatigue? Let staff know they can stand up and
        stretch whenever they would like during the meeting, hold meetings
        around a tall table so everyone can stand, or you could even try a
        walking meeting!
        <br />
        For more ideas on how to create meetings that support employees to be
        healthier download our{" "}
        <a
          className="text-reset text-underline"
          href="https://cdn.livelighter.com.au/assets/resource/workplace/2021-07-healthier-meetings.pdf"
          download="6 setps to a healthier meeting"
          title="Download 6 setps to a healthier meeting"
        >
          6 steps to a healthier meeting
        </a>{" "}
        guide.
      </p>
    ),
  },
  {
    title: "Raise awareness",
    body: (
      <>
        <p className="d-inline-block mb-4">
          You can help raise awareness about healthy behaviours by displaying{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="text-reset text-underline"
            href="/toolbox/download-resources#posters"
          >
            informative posters
          </a>{" "}
          in common areas such as kitchens or meetings rooms or delivering one
          of our{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="text-reset text-underline"
            href="/health-professionals/health-promotion"
          >
            pre-prepared presentations
          </a>{" "}
          to employees. You could also encourage staff to sign up to the{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="text-reset text-underline"
            href="/subscribe"
          >
            LiveLighter newsletter
          </a>{" "}
          for healthy tips and recipes delivered to their inbox each month.
        </p>

        <section className="mb-3">
          <Slider {...settings}>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/poster/ll-sugary-drinks-a3-poster-web.pdf"
              download="sugary drinks poster"
              title="Download sugary drinks poster"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/sugary-drinks-poster.jpg"
                  alt="sugary-drinks-poster"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Sugar in drinks poster</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/infographic/2020-10-26-generic-f-v-month-challenge.pdf"
              download="fruit and veg challenge"
              title="Download fruit and veg LiveLighter challenge"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/fv-challenge.jpg"
                  alt="fruit and veg LiveLighter challenge"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Fruit &amp; veg 30-day challenge</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/physical-activity/move-more-30-day-challenge-a4-and-3-minute-workout.pdf"
              download="Move more 30-day challenge"
              title="Download Move more 30-day challenge"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/mm-challenge.jpg"
                  alt="Move More 30-day challenge"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Move More 30-day challenge</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/factsheet/ll poster - salad builder (ll4202).pdf"
              download="salad builder"
              title="Download salad builder"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/salad-builder.jpg"
                  alt="Salad builder poster"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Salad builder poster</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/factsheet/ll poster - sandwich builder (ll4204).pdf"
              download="sandwich builder"
              title="Download sandwitch builder"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/sandwich-builder.jpg"
                  alt="Sandwich builder poster"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Sandwich builder poster</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/poster/ebll-green-a3.pdf"
              download="eat brighter live lighter - green"
              title="Download eat brighter live lighter - green"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/ebll-green.jpg"
                  alt="eat brighter live lighter - green"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Eat Brighter poster: Green</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/poster/ebll-orange-a3.pdf"
              download="eat brighter live lighter - orange"
              title="Download eat brighter live lighter - orange"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/ebll-orange.jpg"
                  alt="eat brighter live lighter - orange"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Eat Brighter poster: Orange</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/poster/ebll-purple-a3.pdf"
              download="eat brighter live lighter - purple"
              title="Download eat brighter live lighter - purple"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/ebll-purple.jpg"
                  alt="eat brighter live lighter - purple"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Eat Brighter poster: Purple</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/poster/ebll-red-a3.pdf"
              download="eat brighter live lighter - red"
              title="Download eat brighter live lighter - red"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/ebll-red.jpg"
                  alt="eat brighter live lighter - red"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Eat Brighter poster: Red</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="https://cdn.livelighter.com.au/assets/resource/poster/ebll-white-a3.pdf"
              download="eat brighter live lighter - white"
              title="Download eat brighter live lighter - white"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/ebll-white.jpg"
                  alt="eat brighter live lighter - white"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Eat Brighter poster: White</strong>
                </div>
              </div>
            </a>
            <a
              className="slide img-thumbnail"
              href="/health-professionals/health-promotion"
              target="_blank"
              rel="noopener noreferrer"
              title="Find pre-prepared presentation kits"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/presentations.jpg"
                  alt="pre-prepared presentation kits"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Pre-prepared presentation kits</strong>
                </div>
              </div>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="slide img-thumbnail"
              href="/subscribe"
              title="Subscribe to the LiveLighter newsletter"
            >
              <div className="h-100 card">
                <img
                  src="https://cdn.livelighter.com.au/assets/resource/thumbnail/quick-wins/subscribe.jpg"
                  alt="eat brighter live lighter - white"
                />
                <div className="h-100 card-footer bg-warning border-0">
                  <strong>Subscribe to our newsletter</strong>
                </div>
              </div>
            </a>
          </Slider>
        </section>
      </>
    ),
  },
  {
    title: "Only use healthy prizes, gifts and fundraising",
    body: (
      <p>
        Only use healthy prizes, gifts and fundraising. Don’t use alcohol or
        chocolates as{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-reset text-underline"
          href="https://ww2.health.wa.gov.au/-/media/Corp/Documents/Health-for/Healthy-options/PDF/Fundraising-initiatives.pdf"
        >
          fundraising items, prizes or gifts
        </a>
        . Give a healthy cookbook, some sports equipment, or a voucher for some
        activewear. These gifts will be more memorable and your employees’
        health will thank you.
      </p>
    ),
  },
];

export const Hub_QuickWins: React.FC<Record<string, never>> = () => {
  const [activeQuickWin, setActiveQuickWin] = React.useState<number>(0);

  const changeSelected = (id: number) => {
    return id === activeQuickWin
      ? setActiveQuickWin(-1)
      : setActiveQuickWin(id);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        {data.map((_, idx) => (
          <StyledButton
            key={idx}
            onClick={() => changeSelected(idx)}
            active={idx === activeQuickWin}
          >
            <IconDiv
              className={idx === activeQuickWin ? "bg-warning" : "bg-grey"}
            >
              {idx + 1}
            </IconDiv>
          </StyledButton>
        ))}
      </div>
      {activeQuickWin !== -1 && (
        <InformationBox className="bg-primary">
          <h1 className="text-uppercase mb-3">{data[activeQuickWin].title}</h1>
          {data[activeQuickWin].body}
        </InformationBox>
      )}
    </>
  );
};

const StyledButton = styled.button<{ active: boolean }>`
  position: relative;
  width: 100%;
  padding: 0;
  display: flex;
  border: none;
  background-color: transparent;
  transition: all 500ms cubic-bezier(0.34, 1.86, 0.64, 1);
  z-index: ${(p) => (p.active ? 2 : 1)};
  @media screen and (min-width: 768px) {
    transform: ${(p) => (p.active ? "scale(1.5)" : "scale(1)")};
  }
  &:focus {
    outline: none;
  }
  &::after {
    content: "";
    padding-bottom: 100%;
  }
`;

const IconDiv = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.125rem;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 15%;
  @media screen and (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

const InformationBox = styled.div`
  margin: 1rem -2rem 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  color: white;
  text-align: center;
  @media screen and (min-width: 768px) {
    & h1 {
      display: inline-block;
      font-size: 1.75rem;
      margin-bottom: 1rem;
    }
    & p {
      font-size: 1.25rem;
    }
    margin: -2rem -2rem 2rem;
    padding: 4rem 5rem 3rem;
  }
  @media screen and (min-width: 992px) {
    padding: 5rem 5rem 3rem;
  }
`;
